import { useEffect, useState } from 'react';
import { getNextDrawCountdownText } from 'utils/common';

const DrawCountdownString =({ date }: {date: Date}) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const targetDate = new Date(date);

    const update = () => {
        const drawCountdownText = getNextDrawCountdownText(targetDate);
        setTimeLeft(drawCountdownText)
    }

    const interval = setInterval(update, 1000);

    return () => clearInterval(interval); // cleanup
  }, [date]);

  return timeLeft;
}

export default DrawCountdownString;